module.exports = __webpack_public_path__ + "img/Default.1c174826.svg";